import script from "./FiltroAtividade.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroAtividade.vue?vue&type=script&setup=true&lang=js"

import "./FiltroAtividade.vue?vue&type=style&index=0&id=5af76a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af76a98"]])

export default __exports__